<template>
  <div class="elegant-container">
    <v-snackbar v-model="dialog.snackbar" top right color="green" :timeout="4000">
      <span class="body-1 font-weight-light white--text" v-html="message.success"></span>
      <template v-slot:action="{ attrs }">
        <v-btn icon color="white" v-bind="attrs" @click="dialog.snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.approval" width="420" persistent @keydown.esc="dialog.approval = false">
      <v-card class="pa-6" style="border-radius: 12px;">
        <v-card-title class="px-0 pb-2 d-flex align-center pt-0">
          <v-icon left color="#00ADB5" class="mr-2">mdi-check-decagram</v-icon>
          Konfirmasi Approval Retur
        </v-card-title>
        <v-card-text class="px-0 pt-2 pb-0 fs-14" style="color: #495057;">
          Dengan menekan tombol setujui, Anda menyetujui pengajuan retur barang ini. Apakah Anda yakin ingin melanjutkan?
        </v-card-text>
        <v-alert v-if="message.error" type="error" dense outlined class="mt-3">
          {{ message.error }}
        </v-alert>
        <v-card-actions class="px-0 pt-4 pb-0">
          <v-spacer/>
          <v-btn class="text-capitalize" elevation="0" @click="dialog.approval = false" :disabled="process.approval">
            <div class="text-capitalize">Batal</div>
          </v-btn>
          <v-btn color="#00ADB5" class="white--text text-capitalize" depressed @click="submitApproval" :loading="process.approval" :disabled="process.approval">
            Ya, Setujui
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.pembayaran"
      @keydown.esc="dialog.pembayaran = false"
      :fullscreen="dialog.fullscreen"
      width="700"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          <v-icon left color="#1814F3" class="mr-2">mdi-cash</v-icon>
          Pembayaran
          <v-spacer/>
          <v-icon 
            @click="dialog.pembayaran = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="px-0 pb-2 grey--text text--darken-1 fs-14">
          Silakan lengkapi detail pembayaran retur berikut.
        </v-card-subtitle>
        <v-divider class="mb-2"/>
        <!-- Info Invoice/Retur -->
        <div class="mb-4 px-0">
          <v-row dense>
            <v-col cols="6" class="py-1">
              <span class="grey--text fs-13">No. Retur:</span>
              <span class="font-weight-bold ml-1">{{ detail.id || '-' }}</span>
            </v-col>
            <v-col cols="6" class="py-1">
              <span class="grey--text fs-13">Tanggal:</span>
              <span class="font-weight-bold ml-1">{{ detail.created_at ? moment(detail.created_at).format('DD MMM YYYY') : '-' }}</span>
            </v-col>
            <v-col cols="6" class="py-1">
              <span class="grey--text fs-13">Judul:</span>
              <span class="font-weight-bold ml-1">{{ detail.title || '-' }}</span>
            </v-col>
            <v-col cols="6" class="py-1">
              <span class="grey--text fs-13">Nominal:</span>
              <span class="font-weight-bold ml-1">{{ (detail.nominal*1) | price || '-' }}</span>
            </v-col>
          </v-row>
        </div>
        <v-divider class="mb-2"/>
        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          <ValidationObserver 
            ref="form">
            <v-form>

              <ValidationProvider
                name="Metode Pembayaran" 
                rules="required" 
                v-slot="{ errors }">
                <div 
                  class="fs-15 label-input mb-1">
                  Metode Pembayaran
                </div>

                <v-autocomplete
                  v-on:keydown.enter.prevent="save()"
                              
                  filled
                  rounded
                  dense
                  solo

                  color="#718EBF"
                  placeholder="Pilih Metode Pembayaran"
                  v-model="form.payment_method"
                  :items="['Tunai','Transfer']"
                  
                  outlined
                  class="mt-2"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                </v-autocomplete>
              </ValidationProvider>

              <!-- <v-autocomplete
                v-model="form.payment_method"
                :items="['Tunai','Transfer']"
                
                label="Pilih Tipe Pembayaran"
                
                dense
                outlined
                hide-details
                style="width: 100%"
                class="mt-4"
                >
              </v-autocomplete> -->

              <div v-if="form.payment_method === 'Transfer'">
                <ValidationProvider
                  name="Pilih Bank" 
                  rules="required" 
                  v-slot="{ errors }">
                  <div 
                    class="fs-15 label-input mb-1 mt-4">
                    Pilih Bank
                  </div>

                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                                
                    filled
                    rounded
                    dense
                    solo

                    color="#718EBF"
                    item-text="name"
                    item-value="name"
                    placeholder="Pilih Bank"
                    v-model="form.bank"
                    :items="bank"
                    
                    outlined
                    return-object
                    class="mt-2"
                    :error-messages="errors"
                    required
                    style="border-radius: 10px;">
                    <template v-slot:selection="{ item }">
                      <div
                        v-if="item" style="color: #718EBF">
                        {{ item.name }} ({{ item.rek_number }})
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.rek_number }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div>
            </v-form>
          </ValidationObserver>
          <v-divider class="my-4"/>
          <v-alert v-if="message.error.length > 0" type="error" dense outlined class="mb-2">
            <v-icon left color="red" size="18">mdi-alert-circle-outline</v-icon>
            {{ message.error }}
          </v-alert>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="save()"
            :loading="process.form"
            :disabled="process.form"
            width="160"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius mr-2">
            Ya, {{ message.status || 'Bayar' }}
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.pembayaran = false; dialog.fullscreen = false; selected.status = [];"
            :disabled="process.status"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
          <v-btn
            rounded
            width="120"
            @click="dialog.pembayaran = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            :disabled="process.form"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex class="customer-page">
        <div class="animated-bg">
          <div class="bg-shape shape-1"></div>
          <div class="bg-shape shape-2"></div>
          <div class="bg-shape shape-3"></div>
        </div>

        <!-- Page Header -->
        <!-- <div class="page-header">
          <div class="header-content px-2">
            <div class="d-flex">
              <h1>Detail Retur</h1>
            </div>
            <p v-if="Object.keys(detail).length > 0">Informasi lengkap retur {{ detail.number || detail.retur_number || detail.id }}</p>
            <p v-else>Memuat data retur...</p>
          </div>
        </div> -->

        <!-- Main Content -->
        <div class="main-card">
          <!-- Loading State -->
          <div v-if="process.load" class="loading-container">
            <v-progress-circular
              indeterminate
              color="#00ADB5"
              size="64"
              width="6"
              class="mb-4">
            </v-progress-circular>
            <div class="fs-16 font-weight-medium" style="color: #495057;">
              Memuat Data Retur...
            </div>
            <div class="fs-12 mt-2" style="color: #6c757d;">
              Mohon tunggu sebentar
            </div>
          </div>

          <!-- Informasi Retur -->
          <div v-if="!process.load && Object.keys(detail).length > 0" class="form-step">
            <div class="step-header">
              <div class="step-icon teal">
                <v-icon color="white" size="28">mdi-package-variant-closed</v-icon>
              </div>
              <div>
                <h2>Informasi Retur</h2>
                <p>Detail lengkap retur</p>
              </div>
            </div>

            <div class="info-grid">
              <!-- Identitas: nomor & tanggal -->
              <div class="info-card">
                <div class="info-label">
                  <v-icon size="16" class="mr-2" color="#00ADB5">mdi-identifier</v-icon>
                  No. Retur
                </div>
                <div class="info-value">{{ detail.number || detail.retur_number || detail.id || '-' }}</div>
              </div>
              <div class="info-card">
                <div class="info-label">
                  <v-icon size="16" class="mr-2" color="#00ADB5">mdi-calendar</v-icon>
                  Tanggal Retur
                </div>
                <div class="info-value">{{ detail.date ? moment(detail.date).format('DD MMM YYYY') : (detail.created_at ? moment(detail.created_at).format('DD MMM YYYY') : '-') }}</div>
              </div>
              <!-- Pihak & dokumen terkait -->
              <div class="info-card">
                <div class="info-label">
                  <v-icon size="16" class="mr-2" color="#00ADB5">mdi-account</v-icon>
                  Nama Customer
                </div>
                <div class="info-value">{{ detail.customer_name || '-' }}</div>
              </div>
              <div class="info-card">
                <div class="info-label">
                  <v-icon size="16" class="mr-2" color="#00ADB5">mdi-file-document</v-icon>
                  No. Invoice
                </div>
                <div class="info-value">{{ detail.invoice_number || '-' }}</div>
              </div>
              <!-- Nilai -->
              <div class="info-card">
                <div class="info-label">
                  <v-icon size="16" class="mr-2" color="#00ADB5">mdi-cash</v-icon>
                  Total Retur
                </div>
                <div class="info-value">{{ formatPrice(detail.nominal != null && detail.nominal !== '' ? (detail.nominal*1) : (detailItems.length ? totalReturItems : null)) }}</div>
              </div>
              <!-- Pelaksana -->
              <div class="info-card">
                <div class="info-label">
                  <v-icon size="16" class="mr-2" color="#00ADB5">mdi-truck-delivery</v-icon>
                  Nama Driver
                </div>
                <div class="info-value">{{ detail.driver_name || '-' }}</div>
              </div>
              <div class="info-card">
                <div class="info-label">
                  <v-icon size="16" class="mr-2" color="#00ADB5">mdi-account-check</v-icon>
                  Admin Approve
                </div>
                <div class="info-value">{{ detail.admin_name || '-' }}</div>
              </div>
              <!-- Catatan (full width di akhir) -->
              <div class="info-card full-width" v-if="detail.note !== undefined && detail.note !== ''">
                <div class="info-label">
                  <v-icon size="16" class="mr-2" color="#00ADB5">mdi-note-text</v-icon>
                  Catatan
                </div>
                <div class="info-value">{{ detail.note || '-' }}</div>
              </div>
            </div>
          </div>

          <!-- Detail Barang Retur -->
          <div v-if="!process.load && detailItems.length > 0" class="form-step">
            <div class="step-header">
              <div class="step-icon orange">
                <v-icon color="white" size="28">mdi-format-list-bulleted</v-icon>
              </div>
              <div>
                <h2>Detail Barang Retur</h2>
                <p>Daftar barang dalam retur ini</p>
              </div>
            </div>
            <v-row>
              <v-col cols="12" class="my-0 pt-0">
                <div style="overflow: auto;" class="fs-13">
                  <table style="width: 100%;" class="table-retur-detail">
                    <thead>
                      <tr>
                        <th style="height: 50px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">No</th>
                        <th style="height: 50px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">Kode Barang</th>
                        <th style="height: 50px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">Nama Barang</th>
                        <th style="height: 50px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">Qty</th>
                        <th style="height: 50px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">Harga</th>
                        <th style="height: 50px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">Subtotal</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in detailItems" :key="item.id || index">
                        <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">{{ index + 1 }}</td>
                        <td style="border: 1px solid #ededed; padding: 10px;">{{ item.varian_sku || '-' }}</td>
                        <td style="border: 1px solid #ededed; padding: 10px;">{{ item.varian_name || '-' }}</td>
                        <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">{{ item.qty_dus || '0' }}.0.{{ item.qty_pcs || '0' }}</td>
                        <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                          {{
                            (
                              (item.qty_dus * 1) > 0
                                ? ((item.price_dus != null ? item.price_dus : item.price) * 1)
                                : (item.price * 1)
                            ) | price
                          }}
                        </td>
                        <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                          {{
                            (
                              ((item.qty_dus * 1) > 0 ? (item.qty_dus * 1) * ((item.price_dus != null ? item.price_dus : item.price) * 1) : 0) +
                              ((item.qty_pcs * 1) > 0 ? (item.qty_pcs * 1) * (item.price * 1) : 0)
                            ) | price
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-col>
              <v-col cols="12" md="6"></v-col>
              <v-col cols="12" md="6" class="d-flex justify-end pt-2">
                <div class="fs-13">
                  <table style="width: 100%;">
                    <tr>
                      <td class="pa-2 font-weight-bold">Total Retur</td>
                      <td style="width: 80px" class="pa-2 text-center">:</td>
                      <td class="pa-2 text-right font-weight-bold">{{ totalReturItems | price }}</td>
                    </tr>
                  </table>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Form Navigation -->
          <div class="form-nav">
            <v-btn
              v-if="showApprovalButton"
              color="#00ADB5"
              class="white--text"
              depressed
              large
              :loading="process.approval"
              :disabled="process.approval"
              style="min-width: 140px; height: 44px; border-radius: 10px; text-transform: none; font-weight: 600;"
              @click="message.error = ''; dialog.approval = true">
              <v-icon left size="18" class="mr-1">mdi-check-decagram</v-icon>
              Approval
            </v-btn>
            <v-spacer v-if="showApprovalButton"/>
            <v-btn
              to="/retur"
              :disabled="process.form"
              depressed
              large
              class="elegant-btn-cancel"
              style="min-width: 130px; height: 44px; border-radius: 10px; text-transform: none; font-weight: 500; letter-spacing: 0.2px; background: #f5f7fa; color: #5C9EAD;">
              <v-icon left size="16" class="mr-1">mdi-arrow-left</v-icon>
              Kembali
            </v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
  
<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        moment,
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,
        lastIndex: 1,

        dialog: {
          status: false,
          pembayaran: false,
          approval: false,
          snackbar: false,
        },

        order_list: {},
        status: '',

        detail: {},
        detailItemsList: [],

        rejected_reason: '',
        bank: [],

        form: {
          id: '',
          bpb_arr: [],
          payment_method: 'Tunai',
          payment_bank_name: '',
          payment_rek_number: '',
        },
        headers_data: [
          {
            text: 'No',
            width: '80',
            value: 'index',
            freeze: true,
            hide: false
          },
          {
            text: 'Nama',
            width: '100%',
            value: 'varian_name',
            freeze: true,
            hide: false
          }
        
        ],
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },
        total_nominal: 0,

        process: {
          form: false,
          load: false,
          image_url: false,
          approval: false,
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers_data.filter(header => !header.hide)  
      },
      detailItems () {
        return this.detailItemsList || []
      },
      totalReturItems () {
        return this.detailItems.reduce((acc, item) => {
          const qtyDus = item.qty_dus * 1
          const qtyPcs = item.qty_pcs * 1
          const pricePcs = item.price * 1
          const priceDus = ((item.price_dus != null ? item.price_dus : item.price) * 1)

          return acc + ((qtyDus > 0 ? qtyDus * priceDus : 0) + (qtyPcs > 0 ? qtyPcs * pricePcs : 0))
        }, 0)
      },
      showApprovalButton () {
        if (!this.detail || Object.keys(this.detail).length === 0) return false
        if (this.user.category_user_id !== '15') return false
        const v = this.detail.is_warehouse
        return v === 0 || v === '0'
      },
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        const returId = this.$route.params.id

        const listParams = {
          limit: 1,
          page: 1,
          sort: 'id',
          id: returId
        }
        const detailParams = { retur_id: returId }

        try {
          const [listRes, detailRes] = await Promise.all([
            get('admin/customer_retur/data', { params: listParams }),
            get('admin/customer_retur/detail', { params: detailParams })
          ])

          const listData = listRes.data
          if (listData.status === 200 && listData.results && listData.results.data && listData.results.data.length > 0) {
            this.detail = listData.results.data[0]
          }

          const detailData = detailRes.data
          if (detailData.status === 200) {
            const raw = detailData.results != null ? detailData.results : detailData.data
            if (Array.isArray(raw)) {
              this.detailItemsList = raw
            } else if (raw && Array.isArray(raw.data)) {
              this.detailItemsList = raw.data
            } else {
              this.detailItemsList = []
            }
          }
        } catch (e) {
          this.detailItemsList = []
        } finally {
          this.process.load = false
        }
      },
      async submitApproval () {
        this.process.approval = true
        this.message.error = ''
        try {
          const res = await post('admin/customer_retur/approval', {
            data: { id: this.detail.id }
          }).then(r => r.data)
          if (res.status === 200) {
            this.dialog.approval = false
            this.dialog.snackbar = true
            this.message.success = res.message || 'Retur berhasil disetujui.'
            this.fetchDetail()
          } else {
            this.message.error = res.message || 'Gagal menyetujui retur.'
          }
        } catch (e) {
          this.message.error = e?.response?.data?.message || 'Gagal menyetujui retur.'
        } finally {
          this.process.approval = false
        }
      },
      formatPrice (val) {
        if (val == null || val === '' || isNaN(Number(val))) return '-'
        const num = Number(val)
        return 'Rp ' + num.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''
        const isValid = true
        if (isValid) {
          

        this.process.form = true
        let form = {
          invoice_id: this.detail.id,
          payment_method: this.form.payment_method,
          payment_bank_name: this.form.payment_method === 'Tunai' ? '' : this.form.bank.name,
          payment_rek_number: this.form.payment_method === 'Tunai' ? '' : this.form.bank.rek_number
        }

        let url = 'admin/customer_invoice/payment'

        await post(url, {
          data: form
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.pembayaran = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      }
    }
  }
</script>

<style scoped>
.elegant-container { background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%); }
.customer-page { position: relative; padding: 18px; padding-top: 36px; min-height: 100%; }
.animated-bg { position: fixed; top: 0; left: 0; right: 0; bottom: 0; pointer-events: none; overflow: hidden; z-index: 0; }
.bg-shape { position: absolute; border-radius: 50%; opacity: 0.6; animation: float 20s ease-in-out infinite; }
.shape-1 { width: 300px; height: 300px; background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%); top: -100px; right: -50px; filter: blur(60px); animation-delay: 0s; }
.shape-2 { width: 200px; height: 200px; background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%); bottom: 100px; left: -50px; filter: blur(50px); animation-delay: -5s; }
.shape-3 { width: 150px; height: 150px; background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%); top: 50%; right: 20%; filter: blur(40px); animation-delay: -10s; }
@keyframes float { 0%, 100% { transform: translateY(0) rotate(0deg); } 25% { transform: translateY(-20px) rotate(5deg); } 50% { transform: translateY(0) rotate(0deg); } 75% { transform: translateY(20px) rotate(-5deg); } }
.page-header { position: relative; z-index: 1; display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 28px; }
.header-content h1 { font-size: 18px; font-weight: 700; color: #222831; margin: 0 0 4px; letter-spacing: -0.5px; }
.header-content p { font-size: 14px; color: #393E46; margin: 0; }
.main-card { position: relative; z-index: 1; background: white; border-radius: 12px; box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08); border: 1px solid rgba(238, 238, 238, 0.6); overflow: hidden; }
.loading-container { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 24px; min-height: 400px; }
.form-step { padding: 24px; }
.step-header { display: flex; align-items: center; gap: 16px; margin-bottom: 32px; padding-bottom: 24px; border-bottom: 2px solid #f8f9fa; }
.step-icon { width: 42px; height: 42px; border-radius: 6px; display: flex; align-items: center; justify-content: center; }
.step-icon.teal { background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%); box-shadow: 0 8px 20px rgba(0, 173, 181, 0.3); }
.step-icon.orange { background: linear-gradient(135deg, #F07B3F 0%, #F07B3F 100%); box-shadow: 0 8px 20px rgba(240, 123, 63, 0.3); }
.step-header h2 { font-size: 14px; font-weight: 700; color: #222831; margin: 0 0 4px; }
.step-header p { font-size: 12px; color: #393E46; margin: 0; }
.info-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
.info-card.full-width { grid-column: span 3; }
.info-card { background: #f8f9fa; border-radius: 8px; padding: 16px; border: 1px solid #e8eaed; transition: all 0.3s ease; }
.info-card:hover { background: #ffffff; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); transform: translateY(-2px); }
.info-label { display: flex; align-items: center; font-size: 12px; font-weight: 600; color: #6b7280; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.5px; }
.info-value { font-size: 15px; font-weight: 600; color: #222831; word-break: break-word; }
.form-nav { display: flex; align-items: center; padding: 0px 32px; padding-bottom: 24px; background: transparent; justify-content: flex-end; }
.table-retur-detail { border-spacing: 0; border-collapse: collapse; }
.table-retur-detail th, .table-retur-detail td { border: 1px solid #ededed; padding: 10px; }
@media (max-width: 960px) { .info-grid { grid-template-columns: 1fr; } .info-card.full-width { grid-column: span 1; } .page-header { flex-direction: column; align-items: flex-start; } }
@media (max-width: 600px) { .customer-page { padding: 16px; } .header-content h1 { font-size: 16px; } .form-step { padding: 18px; } .bg-shape { opacity: 0.3; } }
</style>